export class Userlogado {
  isOk!: boolean;
  data!: string;
  message!: string;
  email!: string;
  funcao!: number;
}
